import React from 'react';
import { useTranslation } from 'react-i18next';
import { NAMESPACE } from './i18n';

const LANGUAGE_OPTIONS: Array<{ code: string; label: string }> = [
    { code: 'en', label: 'English' },
    { code: 'ar', label: 'العربية' },
    { code: 'ur', label: 'اردو' },
    { code: 'hi', label: 'हिन्दी' },
    { code: 'fr', label: 'Français' },
];

const LanguageSelector: React.FC = () => {
    const { t, i18n } = useTranslation(NAMESPACE);
    const currentCode = (i18n.language || 'en').split(/[-_]/)[0].toLowerCase();
    const isKnown = LANGUAGE_OPTIONS.some(o => o.code === currentCode);

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        i18n.changeLanguage(e.target.value);
    };

    return (
        <span className="hs-lang">
            <svg className="hs-lang-globe" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                <circle cx="12" cy="12" r="10" fill="none" stroke="#fff" strokeWidth="2" />
                <ellipse cx="12" cy="12" rx="4.5" ry="10" fill="none" stroke="#fff" strokeWidth="2" />
                <path d="M2 12h20" fill="none" stroke="#fff" strokeWidth="2" />
            </svg>
            <span className="hs-lang-code" aria-hidden="true">{currentCode.toUpperCase()}</span>
            <span className="hs-lang-caret" aria-hidden="true">▾</span>
            <select
                className="hs-lang-select"
                value={isKnown ? currentCode : ''}
                onChange={handleChange}
                aria-label={t('Select language')}
            >
                {!isKnown && <option value="" disabled hidden />}
                {LANGUAGE_OPTIONS.map(o => (
                    <option key={o.code} value={o.code}>
                        {o.label}
                    </option>
                ))}
            </select>
        </span>
    );
};

export default LanguageSelector;
